import { AccountForChildProductBullets } from '@components/account-for-child-product-bullets/account-for-child-product-bullets';
import { Modal, type ModalDialogProps } from '@eika/modal';
import { format } from '@translation-utils/use-translation';
import { useTranslation } from '@translations';
import { yearsOld } from '@utils/process-utils';
import { PARTIAL_TAKEOVER_AGE } from '@/constants/partial-takeover-age';

type AboutAccountForChildModalProps = ModalDialogProps;

export const AboutAccountForChildModal = (props: AboutAccountForChildModalProps) => {
    const { aboutAccountForChildModal } = useTranslation();

    return (
        <Modal
            {...props}
            title={aboutAccountForChildModal.header}
            description={format(aboutAccountForChildModal.ingress, yearsOld(PARTIAL_TAKEOVER_AGE))}
            shouldCloseOnOverlayClick={true}
            contentShouldStretch
        >
            <AccountForChildProductBullets />
        </Modal>
    );
};
